module.exports = __webpack_public_path__ + "img/LOGO_ GRAY.e5a91e68.png";